import {
  DefaultMixTopic,
  LearnerMixTopic,
} from "@outschool/gql-backend-generated";
import { gql, useQuery } from "@outschool/ui-apollo";

import { DEFAULT_TOPIC_IMAGES, Topic, TopicFilter } from "./consts";

export const LEARNER_MIX_TOPICS_QUERY = gql`
  query LearnerMixTopics {
    learnerMixTopics {
      uid
      title
      description
      attachmentUrl
    }
  }
`;

export const DEFAULT_MIX_TOPICS_QUERY = gql`
  query DefaultMixTopics {
    defaultMixTopics {
      id
      title
      description
    }
  }
`;

export default function useTopicsForFilter(
  filter: TopicFilter,
  selectedTopics: Topic[],
) {
  const {
    data: learnerMixTopicsData,
    loading: learnerMixTopicsLoading,
    error: learnerMixTopicsError,
  } = useQuery(LEARNER_MIX_TOPICS_QUERY, {
    skip: filter === TopicFilter.DefaultTopics && selectedTopics.length === 0,
  });
  const {
    data: defaultMixTopicsData,
    loading: defaultMixTopicsLoading,
    error: defaultMixTopicsError,
  } = useQuery(DEFAULT_MIX_TOPICS_QUERY);
  const learnerMixTopics: Topic[] =
    learnerMixTopicsData?.learnerMixTopics.map((topic: LearnerMixTopic) => ({
      ...topic,
      isDefault: false,
    })) || [];
  const defaultTopics: Topic[] =
    defaultMixTopicsData?.defaultMixTopics.map((topic: DefaultMixTopic) => ({
      uid: topic.id,
      title: topic.title,
      description: topic.description,
      attachmentUrl: DEFAULT_TOPIC_IMAGES[topic.id],
      isDefault: true,
    })) || [];

  switch (filter) {
    case TopicFilter.All:
      return {
        data: [...learnerMixTopics, ...defaultTopics],
        loading: learnerMixTopicsLoading || defaultMixTopicsLoading,
        error: learnerMixTopicsError || defaultMixTopicsError,
      };
    case TopicFilter.MyMixes:
      return {
        data: learnerMixTopics,
        loading: learnerMixTopicsLoading,
        error: learnerMixTopicsError,
      };
    case TopicFilter.DefaultTopics:
      return {
        data: defaultTopics,
        loading: defaultMixTopicsLoading,
        error: defaultMixTopicsError,
      };
  }
}
